<template>
  <div>
    <dialog
      ref="dialogRef"
      :id="id"
      class="media-library-dialog"
      @close="$emit('update:visible', false)"
    >
      <!-- Header -->
      <div class="dialog-header">
        <span>{{ title }}</span>
        <div class="header-actions">
          <!-- Close Button -->
          <span
            class="cross-green"
            aria-label="Close dialog"
            @click="$emit('update:visible', false)"
          >
          </span>
        </div>
      </div>

      <!-- Content Area -->
      <!-- <div class="dialog-content media-content"> -->
      <div class="media-layout">
        <!-- Sidebar -->
        <div class="sidebar">
          <!-- Search -->
          <div class="search-container">
            <div class="search-input-wrapper">
              <span class="search-icon">
                <i class="search-icon-black"></i>
              </span>
              <input
                v-model="searchQuery"
                type="text"
                placeholder="Search..."
                class="search-input"
              />
            </div>
          </div>

          <!-- Add New Folder Button -->
          <ui-button
            @click="NewFolderPopup = true"
            class="add-folder-button"
            variant="primary"
          >
            <i class="plus-icon"></i>
            <label>Add new folder</label>
          </ui-button>

          <!-- Folder List -->
          <div class="folder-list">
            <button
              v-for="folder in filteredFolders"
              :key="folder.id"
              @click="selectFolder(folder.id)"
              :class="['folder-item', { active: selectedFolder === folder.id }]"
            >
              <span class="file-icon-black"></span>
              {{ folder.name }}
            </button>
          </div>
        </div>

        <!-- Main Content -->
        <div class="main-content">
          <div class="main-content-child">
            <!-- Create Dropdown -->
            <div class="dropdown-container">
              <ui-button @click="toggleCreateDropdown" class="create-button">
                <i class="plus-icon"></i>
                <label>Create</label>
                <div class="button-divider"></div>
                <span class="angle-down-white"></span>
              </ui-button>

              <!-- Dropdown Menu -->
              <div v-if="showCreateDropdown" class="dropdown-menu">
                <button @click="openImageDialogBox" class="dropdown-item">
                  <span class="create-image-icon"></span>
                  Image
                </button>
                <button @click="openVideoDialogBox" class="dropdown-item">
                  <span class="create-video-icon"></span>
                  Video
                </button>
              </div>
            </div>

            <!-- Upload Area -->
            <div class="upload-file-container">
              <div class="upload-content">
                <!-- Drop Area or Image Preview -->
                <div class="upload-text-parent" v-if="!localPreviewImageUrl">
                  <span class="upload-icon"></span>
                  <p>Drop files here to upload...</p>
                </div>
                <div class="image-preview-container" v-else>
                  <img
                    :src="localPreviewImageUrl"
                    alt="Uploaded Image"
                    class="image-preview"
                    height="50%"
                    width="50%"
                  />
                </div>
                <!-- Buttons -->
                <div class="upload-actions">
                  <div class="browse-btn-container" v-if="!localPreviewImageUrl">
                    <input
                      type="file"
                      id="fileiddesktopexp"
                      ref="filedesktopexp"
                      accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff, .mp4"
                      @change="handleFileUpload($event)"
                      style="display: none"
                      aria-describedby="photo-help"
                    />
                    <ui-button
                      :label="lmodel.browse || 'Browse'"
                      variant="secondary"
                      icon="browse-icon-green"
                      @click="browseBtn"
                    />
                  </div>
                  <div class="action-buttons" v-else>
                    <ui-button
                      label="Cancel"
                      variant="secondary"
                      @click="cancelUpload"
                      class="cancel-button"
                    />
                    <ui-button
                      label="Save"
                      variant="primary"
                      @click="saveUpload"
                      class="save-button"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Image Grid -->
          <div class="image-grid">
            <div
              v-for="item in filteredFolderItem"
              :key="item.id"
              @click="toggleSelection(item)"
              :class="[
                'image-item',
                { selected: selectedFolderItem.includes(item.id) },
                { 'trimmed-video': item.isTrimmed },
              ]"
            >
              <!-- Video thumbnail -->
              <video
                v-if="item.type === 'video'"
                :src="item.url"
                class="image-thumbnail"
                muted
                loop
              ></video>
              <!-- Image thumbnail -->
              <img
                v-else-if="item.type === 'image'"
                :src="item.url"
                :alt="item.name"
                class="image-thumbnail"
              />

              <div class="image-label">
                <p>{{ item.name }}</p>
                <!-- Show trim duration for trimmed videos -->
                <small v-if="item.isTrimmed" class="trim-info">
                  Duration: {{ formatTime(item.trimData.duration) }}
                </small>
              </div>

              <!-- Trimmed video indicator -->
              <div v-if="item.isTrimmed" class="trimmed-indicator">✂</div>

              <!-- Selection Indicator -->
              <div
                v-if="selectedFolderItem.includes(item.id)"
                class="selection-indicator"
              >
                ✓
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <ui-button
          variant="secondary"
          @click="$emit('update:visible', false)"
          class="cancel-button"
        >
          Cancel
        </ui-button>
        <ui-button
          @click="chooseSelected"
          class="choose-button"
          variant="secondary"
        >
          Choose
        </ui-button>
        <ui-button
          @click="handleEditButtonClick" 
          :disabled="!selectedFolderItem.length"
          class="edit-button"
          variant="primary"
        >
          Edit
        </ui-button>
      </div>
    </dialog>

    <!-- Nested Popups -->

    <!-- Nested popup for image -->
    <DialogVue
      v-model:visible="imageAiPopup"
      @save="handleCreateImage"
      header="Create new content with AI"
      class="image-ai-dialog"
      :showFooter="false"
    >
      <div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Describe the content you want to create"
              :isRequiredTooltipIcon="true"
            />
            <form-textarea
              v-model="contentDescription"
              placeholder="Type here"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared class="label-text" labelvalue="Image setting" />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Negative Text"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Enter negative text"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Width"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="width" placeholder="Add width" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Height"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="height" placeholder="Add Height" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Quality"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="quality" placeholder="Select quality" />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="CFG Scale"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="cfgScale" placeholder="Add CFG Scale" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Seed"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="seed" placeholder="Add seed" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Number Of Images"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="numImages"
              placeholder="Add number of images"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Save to folder"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="saveFolder"
              placeholder="Choose a folder"
            />
          </div>
        </div>
        <div class="grid mt-3">
          <div class="col-12 lg:col-12">
            <ui-button
              label="Generate content"
              @click="openContentGeneratingDialogBoxImage"
              variant="primary"
            />
          </div>
        </div>
      </div>
    </DialogVue>
    <!-- Nested popup for Video -->
    <DialogVue
      v-model:visible="videoAiPopup"
      @save="handleCreateImage"
      header="Create new content with AI"
      class="video-ai-dialog"
      :showFooter="false"
    >
      <div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Describe the content you want to create"
              tooltipvalue="lmodel.voyadoRewardAssignedBodyToolTip"
              :isRequiredTooltipIcon="true"
            />
            <form-textarea
              v-model="contentDescription"
              placeholder="Type here"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared class="label-text" labelvalue="Video setting" />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Add image (optional)"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Enter negative text"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Duration seconds"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="width" placeholder="Add width" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Fps"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="height" placeholder="Add Height" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Dimension"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="quality" placeholder="Select quality" />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Seed"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="seed" placeholder="Add seed" />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Save to folder"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="saveFolder"
              placeholder="Choose a folder"
            />
          </div>
        </div>
        <div class="grid mt-3">
          <div class="col-12 lg:col-12">
            <ui-button
              label="Generate content"
              @click="openContentGeneratingDialogBoxVideo"
              class="p-button-success"
            />
          </div>
        </div>
      </div>
    </DialogVue>

    <!-- Creating image Loader Popup -->
    <DialogVue
      v-model:visible="generatingContentPopUpImage"
      @save="handleCreateImage"
      :showHeader="false"
      class="loading-dialogbox"
      :showFooter="false"
    >
      <div class="loader-popup">
        <i class="spin-icon-white"></i>
        <div class="loader-message">
          <span class="label-text">Your image is being created</span>
          <span class="control-label grd-btm">
            might take a few seconds, you can wait or we'll let you know when
            it's done</span
          >
        </div>
        <ui-button
          label="Dismiss"
          variant="secondary"
          @click="generatingContentPopUpImage = false"
          class="dismiss-button"
        />
      </div>
    </DialogVue>
    <!--Successfully Created image Popup -->
    <DialogVue
      v-model:visible="imageCreatedPopup"
      @save="handleSaveImage"
      :showHeader="false"
      class="created-dialogbox"
      :showFooter="false"
    >
      <div class="created-popup">
        <i class="successfully-generated-icon"></i>
        <div class="message">Your image has been created</div>
        <div class="buttons">
          <ui-button
            label="Dismiss"
            variant="secondary"
            @click="imageCreatedPopup = false"
            class="dismiss-button"
          />
          <ui-button
            label="Go to folder"
            variant="primary"
            @click="goToFolder"
            class="go-to-folder-button"
          />
        </div>
      </div>
    </DialogVue>

    <!-- Creating Video Loader Popup -->
    <DialogVue
      v-model:visible="generatingContentPopUpVideo"
      @save="handleCreateImage"
      :showHeader="false"
      class="loading-dialogbox"
      :showFooter="false"
    >
      <div class="loader-popup">
        <i class="spin-icon-white"></i>
        <div class="loader-message">
          <span class="label-text">Your video is being created</span>
          <span class="control-label grd-btm">
            This might take a few minutes. You can go about your business and
            we’ll let you know when its done</span
          >
        </div>
        <ui-button
          label="Dismiss"
          variant="secondary"
          @click="generatingContentPopUpVideo = false"
          class="dismiss-button"
        />
      </div>
    </DialogVue>
    <!--Successfully Created Video Popup -->
    <DialogVue
      v-model:visible="videoCreatedPopup"
      @save="handleSaveImage"
      :showHeader="false"
      class="created-dialogbox"
      :showFooter="false"
    >
      <div class="created-popup">
        <i class="successfully-generated-icon"></i>
        <div class="message">Your Video has been created</div>
        <div class="buttons">
          <ui-button
            label="Dismiss"
            variant="secondary"
            @click="videoCreatedPopup = false"
            class="dismiss-button"
          />
          <ui-button
            label="Go to folder"
            variant="primary"
            @click="goToFolder"
            class="go-to-folder-button"
          />
        </div>
      </div>
    </DialogVue>

    <!-- Highlighted Image Settings Popup -->
    <DialogVue
      v-model:visible="highlightedImageSettingsPopup"
      @save="saveHighlightedImageSettings"
      header="Image Settings"
      class="highlighted-image-settings-dialog"
      animateFromRight="small"
      :showFooter="false"
    >
      <div class="highlighted-settings-content">
        <!-- ADDED: Display the selected image -->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <img
              :src="selectedImageUrl"
              alt="Selected Image"
              class="preview-image"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              class="control-label"
              labelvalue="Name"
              :isRequiredTooltipIcon="true"
            />
            <div class="grd-btm" style="display: flex; flex-direction: column">
              {{ highlightedImageName }}
            </div>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              class="control-label"
              labelvalue="Height"
              :isRequiredTooltipIcon="true"
            />
            <div class="grd-btm" style="display: flex; flex-direction: column">
              100px
            </div>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              class="control-label"
              labelvalue="Format"
              :isRequiredTooltipIcon="true"
            />
            <div class="grd-btm" style="display: flex; flex-direction: column">
              PNG
            </div>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              class="control-label"
              labelvalue="Width"
              :isRequiredTooltipIcon="true"
            />
            <div class="grd-btm" style="display: flex; flex-direction: column">
              200px
            </div>
          </div>
        </div>
        <div class="border-line mt-2 mb-2" style="margin: 0px -32px"></div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label"
              labelvalue="Edit"
              :isRequiredTooltipIcon="true"
            />
          </div>
          <div class="col-12 lg:col-12">
            <ui-button
              label="crop"
              class="mr-2"
              icon="crop-light-green"
              @click="openImageSettingCropPopup"
              variant="secondary"
            />
            <ui-button
              label="Remove background"
              icon="Remove_bg_icon"
              class="mr-2"
              @click="openBackgroundRemovalPopup"
              variant="secondary"
            />
            <ui-button
              label="Resize"
              icon="cross-resize-icon"
              @click="openImageSettingResizePopup"
              variant="secondary"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label"
              labelvalue="Iterate"
              :isRequiredTooltipIcon="true"
            />
          </div>
          <div class="col-12 lg:col-12">
            <ui-button
              label="Brand colorise"
              class="mr-2 mb-2"
              icon="color-plate-icon"
              @click="null"
              variant="secondary"
            />
            <ui-button
              label="Create a video"
              icon="video-player-icon"
              class="mr-2"
              @click="null"
              variant="secondary"
            />
            <ui-button
              label="Variant"
              icon="magic-wand-icon"
              class="mr-2"
              @click="openImageSettingVariantPopup"
              variant="secondary"
            />
            <ui-button
              label="Outpaint"
              icon="cross-resize-icon"
              class="mr-2"
              @click="openImageSettingOutpaintingPopup"
              variant="secondary"
            />
            <ui-button
              label="Inpaint"
              icon="paint-brush-icon"
              @click="openImageSettingInpaintingPopup"
              variant="secondary"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label"
              labelvalue="Manage"
              :isRequiredTooltipIcon="true"
            />
          </div>
          <div class="col-12 lg:col-12">
            <ui-button
              label="Download"
              class="mr-2"
              icon="download-green-icon"
              @click="null"
              variant="secondary"
            />
            <ui-button
              label="Delete"
              icon="trash-icon"
              class="mr-2"
              @click="null"
              variant="secondary"
            />
          </div>
        </div>
      </div>
    </DialogVue>

    <!-- Image setting - Variant  -->
    <DialogVue
      v-model:visible="ImageSettingVariantPopup"
      @save="handleCreateImage"
      header="Image setting - Variant"
      class="image-setting-onclick-butoon"
      :showFooter="false"
    >
      <div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Selected image"
              :isRequiredTooltipIcon="true"
            />
          </div>
          <div class="col-12 lg:col-12">
            <img
              :src="selectedImageUrl"
              alt="Selected Image"
              class="preview-image"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Negative Text"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Enter negative text"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Width"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="width" placeholder="Add width" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Height"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="height" placeholder="Add Height" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Quality"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="quality" placeholder="Select quality" />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="CFG Scale"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="cfgScale" placeholder="Add CFG Scale" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Seed"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="seed" placeholder="Add seed" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Number Of Images"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="numImages"
              placeholder="Add number of images"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Similarity Strength"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="saveFolder"
              placeholder="Add similarity stength"
            />
          </div>
        </div>
        <div class="grid mt-3">
          <div class="col-12 lg:col-12">
            <ui-button
              label="Generate content"
              @click="openContentGeneratingDialogBoxImage"
              variant="primary"
            />
          </div>
        </div>
      </div>
    </DialogVue>

    <!-- Image setting - Inpainting  -->
    <DialogVue
      v-model:visible="ImageSettingInpaintingPopup"
      @save="handleCreateImage"
      header="Image setting - Inpainting"
      class="image-setting-onclick-butoon"
      :showFooter="false"
    >
      <div>
        <div class="grid">
          <!-- selected image -->
          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Selected image"
              :isRequiredTooltipIcon="true"
            />
          </div>
          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Mask image"
              :isRequiredTooltipIcon="true"
            />
          </div>

          <div class="col-12 lg:col-6">
            <img
              :src="selectedImageUrl"
              alt="Selected Image"
              class="preview-image"
            />
          </div>
          <div class="col-12 lg:col-6">
            <img
              :src="selectedImageUrl"
              alt="Mask Image"
              class="preview-image"
            />
          </div>

          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Mask prompt"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Enter mask prompt"
            />
          </div>
          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Mask Image"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Select Image"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Negative Text"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Enter negative text"
            />
          </div>
        </div>

        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="CFG Scale"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="cfgScale" placeholder="Add CFG Scale" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Seed"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="seed" placeholder="Add seed" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Number Of Images"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="numImages"
              placeholder="Add number of images"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Number Of Images"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="saveFolder"
              placeholder="Add Number Of Images"
            />
          </div>
        </div>
        <div class="grid mt-3">
          <div class="col-12 lg:col-12">
            <ui-button
              label="Generate content"
              @click="openContentGeneratingDialogBoxImage"
              variant="primary"
            />
          </div>
        </div>
      </div>
    </DialogVue>

    <!-- Image setting - Outpainting  -->
    <DialogVue
      v-model:visible="ImageSettingOutpaintingPopup"
      @save="handleCreateImage"
      header="Image setting - Outpainting"
      class="image-setting-onclick-butoon"
      :showFooter="false"
    >
      <div>
        <div class="grid">
          <!-- selected image -->
          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Selected image"
              :isRequiredTooltipIcon="true"
            />
          </div>
          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Mask image"
              :isRequiredTooltipIcon="true"
            />
          </div>

          <div class="col-12 lg:col-6">
            <img
              :src="selectedImageUrl"
              alt="Selected Image"
              class="preview-image"
            />
          </div>
          <div class="col-12 lg:col-6">
            <img
              :src="selectedImageUrl"
              alt="Mask Image"
              class="preview-image"
            />
          </div>

          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Mask prompt"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Enter mask prompt"
            />
          </div>
          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Mask Image"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Select Image"
            />
          </div>
        </div>

        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Negative Text"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="negativeText"
              placeholder="Enter negative text"
            />
          </div>
        </div>

        <div class="grid">
          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Out Painting mode"
              :isRequiredTooltipIcon="true"
            />
            <form-select v-model="cfgScale" placeholder="Add CFG Scale" />
          </div>
          <div class="col-12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Quality"
              :isRequiredTooltipIcon="true"
            />
            <form-select v-model="seed" placeholder="Add seed" />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="CFG Scale"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="cfgScale" placeholder="Add CFG Scale" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Seed"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text v-model="seed" placeholder="Add seed" />
          </div>
          <div class="col-12 lg:col-4">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Number Of Images"
              :isRequiredTooltipIcon="true"
            />
            <form-input-text
              v-model="numImages"
              placeholder="Add number of images"
            />
          </div>
        </div>
        <div class="grid mt-3">
          <div class="col-12 lg:col-12">
            <ui-button
              label="Generate content"
              @click="openContentGeneratingDialogBoxImage"
              variant="primary"
            />
          </div>
        </div>
      </div>
    </DialogVue>

    <!-- Image setting - Resize  -->
    <DialogVue
      v-model:visible="ImageSettingResizePopup"
      @save="handleCreateImage"
      header="Image resize"
      class="image-setting-onclick-butoon-resize"
      :showFooter="false"
    >
      <div>
        <div class="col-12 lg:col-12">
          <img :src="selectedImageUrl" alt="Mask Image" class="preview-image" />
        </div>
        <div
          class="col-12 lg:col-12"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <label-shared
            class="label-text-without-mb"
            labelvalue="Image history"
          />
          <ui-button
            variant="secondary"
            size="small"
            label="Clear all"
          ></ui-button>
        </div>
        <div class="image-grid">
          <!-- COMMENT: Added static resized images for resize example -->
          <div
            v-for="image in staticResizedImages"
            :key="image.id"
            @click="selectImageForResize(image)"
            :class="[
              'image-item image-grid-with-transition-label',
              { selected: selectedImagesForResize.includes(image.id) },
            ]"
          >
            <img
              :src="image.url"
              :alt="image.name"
              class="image-thumbnail-resize"
            />
            <div class="image-label-resize">
              <p>600*600</p>
            </div>
            <!-- Selection Indicator -->
            <div
              v-if="selectedImagesForResize.includes(image.id)"
              class="selection-indicator-resize"
            >
              ×
            </div>
          </div>
        </div>
        <div style="display: flex" class="mt-2">
          <form-checkbox />
          <label-shared labelvalue="Maintain aspect ratio" />
        </div>
        <div class="grid">
          <div class="col:12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Width (PX)"
            />
            <form-input-text v-model="numImages" placeholder="Add Width" />
          </div>
          <div class="col:12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Height (PX)"
            />
            <form-input-text v-model="numImages" placeholder="Add Height" />
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 10px;
          "
        >
          <ui-button variant="secondary" label="Close"></ui-button>
          <ui-button variant="primary" label="Save"></ui-button>
        </div>
      </div>
    </DialogVue>

    <!-- Image setting - Crop  -->
    <DialogVue
      v-model:visible="ImageSettingCropPopup"
      @save="handleCrop"
      header="Image Crop"
      class="image-setting-onclick-butoon-resize"
      :showFooter="false"
    >
      <div>
        <div class="col-12 lg:col-12">          
          <cropper
            v-if="ImageSettingCropPopup && cropperSrc"
            class="imagefit"
            :src="cropperSrc"
            :auto-zoom="true"
            :check-orientation="false"
            :resize-image="{ adjustStencil: false }"
            :default-size="{ width: 300, height: 300 }"
            ref="cropperComponent"
            @error="onCropperError"
            @ready="onCropperReady"
            @change="onCropperChange"
          />
          
          <!-- Loading state -->
          <div v-else-if="ImageSettingCropPopup && !cropperSrc" class="cropper-loading">
            <div class="spinner"></div>
            <p>Loading image for cropping...</p>
          </div>
        </div>
        <div
          class="col-12 lg:col-12"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <label-shared
            class="label-text-without-mb"
            labelvalue="Image history"
          />
          <ui-button
            variant="secondary"
            size="small"
            label="Clear all"
            @click="clearCroppedImages"
          ></ui-button>
        </div>
        <div v-if="croppedImages.length > 0" style="margin: 10px 0; padding: 8px; background: #f0f8ff; border-radius: 4px; font-size: 12px; color: #666;">
          <i class="fa fa-info-circle" style="margin-right: 5px;"></i>
          Click on any image below to select it, then click "Save Selected" to apply your choice.
        </div>
        <div class="image-grid">
          <div
            class="image-item image-grid-with-transition-label"
            :class="{ selected: selectedImagesForCrop.includes(0) }"
            @click="selectImageForCrop(0)"
          >
            <img
              :src="selectedImageUrl"
              alt="Original Image"
              class="image-thumbnail-resize"
            />
            <div class="image-label-resize">
              <p>Original</p>
            </div>
            <div
              v-if="selectedImagesForCrop.includes(0)"
              class="selection-indicator-resize"
            >
              ✓
            </div>
            <div
              v-else
              class="selection-indicator-resize"
              style="background: rgba(0,0,0,0.3); color: #ccc;"
            >
              ○
            </div>
          </div>
          <div
            v-for="(image, index) in croppedImages"
            :key="`crop-${index + 1}`"
            class="image-item image-grid-with-transition-label"
            :class="{ selected: selectedImagesForCrop.includes(index + 1) }"
            @click="selectImageForCrop(index + 1)"
          >
            <img
              :src="image.url"
              :alt="`Cropped Image ${index + 1}`"
              class="image-thumbnail-resize"
            />
            <div class="image-label-resize">
              <p>{{ `Cropped ${index + 1}` }}</p>
            </div>
            <div
              v-if="selectedImagesForCrop.includes(index + 1)"
              class="selection-indicator-resize"
            >
              ✓
            </div>
            <div
              v-else
              class="selection-indicator-resize"
              style="background: rgba(0,0,0,0.3); color: #ccc;"
            >
              ○
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 15px;
          "
        >
          <ui-button
            variant="secondary"
            label="Close"
            @click="ImageSettingCropPopup = false"
          ></ui-button>
          <ui-button
            v-if="croppedImages.length < 2"
            variant="primary"
            label="Apply Crop"
            @click="applyCrop"
          ></ui-button>
          <ui-button
            v-if="croppedImages.length >= 1"
            variant="primary"
            :label="selectedImagesForCrop.length > 0 ? 'Save Selected' : 'Save (Select Image First)'"
            @click="handleCrop"
            :disabled="selectedImagesForCrop.length === 0"
          ></ui-button>
        </div>
      </div>
    </DialogVue>

    <!--Highlighted Video Settings Popup  -->
    <DialogVue
      v-model:visible="highlightedVideoSettingsPopup"
      @save="saveHighlightedVideoSettings"
      header="Video Settings"
      class="highlighted-video-settings-dialog"
      animateFromRight="small"
      :showFooter="false"
    >
      <div class="highlighted-settings-content">
        <!-- ADDED: Display the selected video -->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <video
              :src="selectedImageUrl"
              class="preview-image"
              controls
            ></video>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              class="control-label"
              labelvalue="Name"
              :isRequiredTooltipIcon="true"
            />
            <div class="grd-btm" style="display: flex; flex-direction: column">
              {{ highlightedImageName }}
            </div>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              class="control-label"
              labelvalue="Duration"
              :isRequiredTooltipIcon="true"
            />
            <div class="grd-btm" style="display: flex; flex-direction: column">
              30s
              <!-- Placeholder value -->
            </div>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              class="control-label"
              labelvalue="Format"
              :isRequiredTooltipIcon="true"
            />
            <div class="grd-btm" style="display: flex; flex-direction: column">
              MP4
            </div>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              class="control-label"
              labelvalue="Resolution"
              :isRequiredTooltipIcon="true"
            />
            <div class="grd-btm" style="display: flex; flex-direction: column">
              1920x1080
            </div>
          </div>
        </div>
        <div class="border-line mt-2 mb-2" style="margin: 0px -32px"></div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label"
              labelvalue="Edit"
              :isRequiredTooltipIcon="true"
            />
          </div>
          <div class="col-12 lg:col-12">
            <ui-button
              label="Crop"
              class="mr-2"
              icon="crop-light-green"
              @click="openVideoSettingCropPopup"
              variant="secondary"
            />
            <ui-button
              label="Trim"
              class="mr-2"
              icon="trim-scissor-icon"
              @click="openVideoSettingTrimPopup"
              variant="secondary"
            />
            <ui-button
              label="Resize"
              class="mr-2"
              icon="cross-resize-icon"
              @click="openVideoSettingResizePopup"
              variant="secondary"
            />
            <ui-button
              label="Convert"
              class="mr-2"
              icon="convert-icon"
              @click="null"
              variant="secondary"
            />
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <label-shared
              class="control-label"
              labelvalue="Manage"
              :isRequiredTooltipIcon="true"
            />
          </div>
          <div class="col-12 lg:col-12">
            <ui-button
              label="Download"
              class="mr-2"
              icon="download-green-icon"
              @click="null"
              variant="secondary"
            />
            <ui-button
              label="Delete"
              icon="trash-icon"
              class="mr-2"
              @click="null"
              variant="secondary"
            />
          </div>
        </div>
      </div>
    </DialogVue>

    <!-- Video setting - Crop  -->
    <DialogVue
      v-model:visible="VideoSettingCropPopup"
      @save="handleCreateImage"
      header="Video resize"
      class="image-setting-onclick-butoon-resize"
      :showFooter="false"
    >
      <div>
        <div class="col-12 lg:col-12">
          <video
            :src="selectedImageUrl"
            alt="Selected Video"
            class="preview-image"
            controls
          ></video>
        </div>
        <div
          class="col-12 lg:col-12"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <label-shared
            class="label-text-without-mb"
            labelvalue="Image history"
          />
          <ui-button
            variant="secondary"
            size="small"
            label="Clear all"
          ></ui-button>
        </div>
        <div class="image-grid">
          <!-- COMMENT: Added static resized images for resize example -->
          <div
            v-for="image in staticResizedImages"
            :key="image.id"
            @click="selectImageForResize(image)"
            :class="[
              'image-item image-grid-with-transition-label',
              { selected: selectedImagesForResize.includes(image.id) },
            ]"
          >
            <img
              :src="image.url"
              :alt="image.name"
              class="image-thumbnail-resize"
            />
            <div class="image-label">
              <p>{{ image.name }}</p>
            </div>
            <!-- Selection Indicator -->
            <div
              v-if="selectedImagesForResize.includes(image.id)"
              class="selection-indicator-resize"
            >
              ×
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 15px;
          "
        >
          <ui-button variant="secondary" label="Close"></ui-button>
          <ui-button variant="primary" label="Save"></ui-button>
        </div>
      </div>
    </DialogVue>

    <!-- Video setting - Resize  -->
    <DialogVue
      v-model:visible="VideoSettingResizePopup"
      @save="handleCreateImage"
      header="Video resize"
      class="image-setting-onclick-butoon-resize"
      :showFooter="false"
    >
      <div>
        <div class="col-12 lg:col-12">
          <video
            :src="selectedImageUrl"
            alt="Selected Video"
            class="preview-image"
            controls
          ></video>
        </div>
        <div
          class="col-12 lg:col-12"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <label-shared
            class="label-text-without-mb"
            labelvalue="Image history"
          />
          <ui-button
            variant="secondary"
            size="small"
            label="Clear all"
          ></ui-button>
        </div>
        <div class="image-grid">
          <!-- COMMENT: Added static resized images for resize example -->
          <div
            v-for="image in staticResizedImages"
            :key="image.id"
            @click="selectImageForResize(image)"
            :class="[
              'image-grid-with-transition-label',
              { selected: selectedImagesForResize.includes(image.id) },
            ]"
          >
            <img
              :src="image.url"
              :alt="image.name"
              class="image-thumbnail-resize"
            />
            <div class="image-label-resize">
              <p>600*600</p>
            </div>
            <!-- Selection Indicator -->
            <div
              v-if="selectedImagesForResize.includes(image.id)"
              class="selection-indicator-resize"
            >
              ×
            </div>
          </div>
        </div>
        <div style="display: flex" class="mt-2">
          <form-checkbox />
          <label-shared labelvalue="Maintain aspect ratio" />
        </div>
        <div class="grid">
          <div class="col:12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Width (PX)"
            />
            <form-input-text v-model="numImages" placeholder="Add Width" />
          </div>
          <div class="col:12 lg:col-6">
            <label-shared
              class="control-label grd-btm"
              labelvalue="Height (PX)"
            />
            <form-input-text v-model="numImages" placeholder="Add Height" />
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 10px;
          "
        >
          <ui-button variant="secondary" label="Close"></ui-button>
          <ui-button variant="primary" label="Save"></ui-button>
        </div>
      </div>
    </DialogVue>

    <!-- Video setting - Trim  -->
    <DialogVue
      v-model:visible="VideoSettingTrimPopup"
      @save="handleCreateImage"
      header="Video Trim"
      class="image-setting-onclick-butoon-resize"
      :showFooter="false"
    >
      <div class="video-trimmer-container">
        <!-- Video Preview -->
        <div class="video-preview-section">
          <video
            ref="videoElement"
            :src="selectedImageUrl"
            class="preview-video"
            @loadedmetadata="onVideoLoaded"
            @timeupdate="onTimeUpdate"
            @ended="onVideoEnded"
          ></video>
        </div>

        <!-- Timeline Scrubber -->
        <div class="timeline-container">
          <div class="timeline-header">
            <span class="control-label">{{ formatTime(trimStart) }}</span>
            <span class="control-label"
              >Duration: {{ formatTime(trimEnd - trimStart) }}</span
            >
            <span class="control-label">{{ formatTime(trimEnd) }}</span>
          </div>

          <div
            class="timeline-wrapper"
            ref="timelineWrapper"
            @mousedown="onTimelineMouseDown"
          >
            <!-- Timeline Track -->
            <div class="timeline-track">
              <!-- Thumbnails (Fixed, Full Width) -->
              <div
                class="timeline-thumbnails"
                :style="{ left: '0%', width: '100%' }"
              >
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(229, 231, 235)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(243, 244, 246)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(229, 231, 235)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(243, 244, 246)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(229, 231, 235)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(243, 244, 246)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(229, 231, 235)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(243, 244, 246)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(229, 231, 235)"
                ></div>
                <div
                  class="timeline-thumbnail"
                  style="flex: 1 1 0%; background-color: rgb(243, 244, 246)"
                ></div>
              </div>
              <!-- Trimmed Section Overlay (Dynamic Borders) -->
              <div
                class="trimmed-section-overlay"
                :style="{
                  left: `${(trimStart / duration) * 100}%`,
                  width: `${((trimEnd - trimStart) / duration) * 100}%`,
                }"
              ></div>
            </div>

            <!-- Current Time Indicator -->
            <div
              class="current-time-indicator"
              :style="{ left: `${(currentTime / duration) * 100}%` }"
            ></div>

            <!-- Start Trim Handle -->
            <div
              class="trim-handle start-handle"
              :style="{ left: `${(trimStart / duration) * 100}%` }"
              @mousedown="onStartHandleMouseDown"
            ></div>

            <!-- End Trim Handle -->
            <div
              class="trim-handle end-handle"
              :style="{ left: `${(trimEnd / duration) * 100}%` }"
              @mousedown="onEndHandleMouseDown"
            ></div>
          </div>

          <!-- Video Controls -->
          <div class="video-controls">
            <div
              @click="togglePlayPause"
              class="control-btn"
              :class="{ playing: isPlaying }"
            >
              <span style="cursor: pointer" class="fast-backward-btn"></span>
              <span
                style="cursor: pointer"
                v-if="!isPlaying"
                class="Play-btn-black"
              ></span>
              <span
                style="cursor: pointer"
                v-else
                class="Pause-btn-black"
              ></span>
              <span style="cursor: pointer" class="fast-forward-btn"></span>
            </div>

            <div class="time-display">
              {{ formatTime(currentTime) }} / {{ formatTime(duration) }}
            </div>
          </div>
        </div>

        <div
          class="col-12 lg:col-12"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <label-shared
            class="label-text-without-mb"
            labelvalue="Video history"
          />
          <ui-button
            variant="secondary"
            size="small"
            label="Clear all"
          ></ui-button>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <div class="left-actions">
            <ui-button @click="resetTrim" variant="primary" label="Undo">
            </ui-button>
            <ui-button @click="previewTrim" variant="primary" label="Preview">
            </ui-button>
          </div>

          <div class="right-actions">
            <ui-button
              @click="VideoSettingTrimPopup = false"
              label="Cancel"
              variant="secondary"
            >
            </ui-button>
            <ui-button @click="saveTrim" variant="primary" label="Trim & Save">
            </ui-button>
          </div>
        </div>
      </div>
    </DialogVue>
    
    <!-- Add new folder popup -->
    <DialogVue
      v-model:visible="NewFolderPopup"
      header="Add new Folder"
      :showFooter="false"
    >
      <div class="popup-content">
        <form @submit.prevent="saveNewFolder">
          <div class="form-group">
            <label for="folderName">Folder Name</label>
            <input
              v-model="newFolderName"
              type="text"
              id="folderName"
              class="folder-name-input"
              placeholder="Enter folder name"
              required
            />
          </div>
          <div class="popup-actions">
            <ui-button
              label="Cancel"
              variant="secondary"
              @click="NewFolderPopup = false"
              class="cancel-button"
            />
            <ui-button
              type="submit"
              label="Save"
              variant="primary"
              class="save-button"
              @click="NewFolderPopup = false"
            />
          </div>
        </form>
      </div>
    </DialogVue>

    <!-- Background Removal Confirmation popup -->
    <DialogVue
      v-model:visible="backgroundRemovalPopup"
      header="Remove Background"
      :showFooter="false"
    >
      <div class="popup-content">
        <!-- Show spinner when processing -->
        <div v-if="isRemovingBackground" class="loader-popup">
          <i class="spin-icon-white"></i>
          <div class="loader-message">
            <span class="label-text">Removing background</span>
            <span class="control-label grd-btm">
              This may take a few moments, please wait...</span>
          </div>
        </div>
        
        <!-- Show confirmation when not processing -->
        <div v-else>
          <div class="confirmation-content">
            <div class="selected-image-preview" v-if="selectedImageUrl">
              <img :src="selectedImageUrl" alt="Selected Image" class="preview-image" />
            </div>
            <p class="confirmation-text">
              Are you sure you want to remove the background from "{{ highlightedImageName }}"?
            </p>
            <p class="info-text">
              This process may take a few moments. The processed image will be added to your media library.
            </p>
          </div>
          <div class="popup-actions">
            <ui-button
              label="Cancel"
              variant="secondary"
              @click="backgroundRemovalPopup = false"
              class="cancel-button"
            />
            <ui-button
              label="Remove Background"
              variant="primary"
              @click="confirmRemoveBackground"
              class="confirm-button"
            />
          </div>
        </div>
      </div>
    </DialogVue>

    <!-- Crop Confirmation popup -->
    <DialogVue
      v-model:visible="cropConfirmationPopup"
      header="Crop Image"
      :showFooter="false"
    >
      <div class="popup-content">
        <div class="confirmation-content">
          <div class="selected-image-preview" v-if="selectedImageUrl">
            <img :src="selectedImageUrl" alt="Selected Image" class="preview-image" />
          </div>
          <p class="confirmation-text">
            Do you want to crop "{{ highlightedImageName }}"?
          </p>
          <p class="info-text">
            This will open the crop editor where you can adjust the image dimensions.
          </p>
        </div>
        <div class="popup-actions">
          <ui-button
            label="Cancel"
            variant="secondary"
            @click="cropConfirmationPopup = false"
            class="cancel-button"
          />
          <ui-button
            label="Start Cropping"
            variant="primary"
            @click="confirmCrop"
            class="confirm-button"
          />
        </div>
      </div>
    </DialogVue>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import DataLayerService from "@/services/data-layer.service.js";
import labelSharedVue from "@/components/shared/label-shared.vue";
import axios from "axios";

export default {
  components: {
    Cropper,
    "label-shared": labelSharedVue,
  },
  data() {
    return {
      objectKey: "",
      cropperSrc: null, // Local blob URL for cropper
      useLocalUrl: true, // Flag to use local URL for cropping
      localImageUrl: null, // Store S3 URL for restoration
      originalFile: null, // Store original file if available
      img: "https://picsum.photos/seed/picsum/200/300",
      imageAiPopup: false,
      videoAiPopup: false,
      generatingContentPopUpImage: false,
      generatingContentPopUpVideo: false,
      imageCreatedPopup: false,
      videoCreatedPopup: false,
      ImageSettingVariantPopup: false,
      ImageSettingInpaintingPopup: false,
      ImageSettingOutpaintingPopup: false,
      ImageSettingResizePopup: false,
      VideoSettingResizePopup: false,
      VideoSettingTrimPopup: false,
      NewFolderPopup: false,
      ImageSettingCropPopup: false,
      VideoSettingCropPopup: false,
      backgroundRemovalPopup: false,
      isRemovingBackground: false, // Loading state for background removal
      cropConfirmationPopup: false,
      vmodel: {},
      lmodel: {},
      searchQuery: "",
      selectedFolder: 1,
      selectedFolderItem: [],
      showCreateDropdown: false,
      folders: [
      ],
      FolderItem: [],
      // Local data properties to avoid mutating props
      localPreviewImageUrl: null,
      localSelectedFile: null,
      staticResizedImages: [
        {
          id: 101,
          name: "Resized Small (100x100)",
          url: "https://picsum.photos/seed/picsum/200/300",
          folderId: 1,
        },
        {
          id: 102,
          name: "Resized Medium (200x200)",
          url: "https://picsum.photos/seed/picsum/200/300",
          folderId: 1,
        },
        {
          id: 103,
          name: "Resized Large (300x300)",
          url: "https://picsum.photos/seed/picsum/200/300",
          folderId: 1,
        },
      ],
      contentDescription: "",
      negativeText: "",
      width: "",
      height: "",
      quality: "",
      cfgScale: "",
      seed: "",
      numImages: "",
      saveFolder: "",
      highlightedImageSettingsPopup: false, // ADDED: New popup visibility flag
      highlightedVideoSettingsPopup: false, // ADDED: New popup visibility flag
      highlightedImageName: "", // ADDED: New data field for image name
      selectedImageUrl: "", // ADDED: New data field to store the selected image URL
      selectedImagesForResize: [],
      croppedImages: [], // ADDED: Array to store cropped images
      selectedImagesForCrop: [],

      videoElement: null,
      duration: 0,
      currentTime: 0,
      isPlaying: false,
      trimStart: 0,
      trimEnd: 0,
      isDragging: false,
      dragType: null, // 'start', 'end', or 'timeline'
      timelineWrapper: null,
      trimmedVideos: [], // Store references to trimmed videos
      currentTrimData: null, // Store current video's trim data
      newFolderName: "", // Store new folder name for API call
    };
  },
  watch: {
    visible(newVal) {
      const dialog = this.$refs.dialogRef;
      if (!dialog) return;
      if (newVal) {
        document.body.classList.add("no-scroll", "dialog-open");
        if (!dialog.open) {
          try {
            dialog.showModal();
          } catch (err) {
            console.warn("Dialog already open:", err);
          }
        }
        // Call getData and getLabel when dialog opens
        this.getData();
        this.getLabel();
      } else {
        document.body.classList.remove("no-scroll", "dialog-open");
        if (dialog.open) {
          dialog.close();
        }
        this.resetState();
      }
    },
  },
  methods: {
    async getData() {
      this.isLoadingImages = true;
      let companyId = this.$store.state.cognitoInfo.companyid;
      
      try {
        // Fetch folders list
        await this.getFolders(companyId);
        
        // Fetch images
        const result = await DataLayerService.get(
          `/MediaLibrary/GetContenthubImages/${companyId}`,
          false
        );
        if (result.success && result.data) {
          const newImages = result.data.map((item) => ({
            id: item.id,
            name: item.imageName,
            url: item.imagePath,
            folderId: this.selectedFolder || 1,
            type: "image",
          }));
          this.FolderItem = [...this.FolderItem, ...newImages]; // Append new images
        } else {
          console.error(
            "No data found in response or request failed:",
            result.message
          );
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: result.message || "Failed to load images",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Error fetching data",
          life: 3000,
        });
      } finally {
        this.isLoadingImages = false;
      }
    },

    async getFolders(companyId) {
      try {
        const response = await DataLayerService.get(
          `/ai/get-folders?cid=${companyId}`
        );
        
        if (response && response.success && response.data && Array.isArray(response.data)) {
          // Handle the API response format with success, data structure
          this.folders = response.data.map(folder => ({
            id: folder.fid, // Use fid as the folder ID (can be string or number)
            name: folder.fname, // Use fname as the folder name
            items: folder.items || [] // Initialize empty items array if not provided
          }));
          
          // Set the first folder as selected if no folder is currently selected
          if (this.folders.length > 0 && !this.selectedFolder) {
            this.selectedFolder = this.folders[0].id;
          }
        } else if (response && Array.isArray(response)) {
          // Handle direct array response (fallback)
          this.folders = response.map(folder => ({
            id: folder.fid || folder.id,
            name: folder.fname || folder.name,
            items: folder.items || []
          }));
          
          // Set the first folder as selected if no folder is currently selected
          if (this.folders.length > 0 && !this.selectedFolder) {
            this.selectedFolder = this.folders[0].id;
          }
        } else {
          console.log("No folders found or invalid response format");
          // Keep default folder if no folders are returned
        }
        
        console.log("Folders loaded:", this.folders);
      } catch (error) {
        console.error("Error fetching folders:", error);
        
        // Show error toast
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: error.message || "Failed to load folders",
          life: 5000,
        });
      }
    },

    async getMediaByFolder(folderId) {
      try {
        const companyId = this.$store.state.cognitoInfo.companyid;
        
        const response = await DataLayerService.get(
          `/ai/get-media-by-folder?cid=${companyId}&fid=${folderId}`
        );
        
        if (response && response.success && response.data && Array.isArray(response.data)) {
          // Handle the API response format with success, data structure
          const mediaItems = response.data.map(item => ({
            id: item.imageId,
            name: item.imageName,
            url: `https://${item.imagePath}`,
            folderId: folderId,
            type: this.getFileTypeFromName(item.imageName),
          }));
          
          // Filter and replace items for this folder
          this.FolderItem = this.FolderItem.filter(item => item.folderId !== folderId);
          this.FolderItem = [...this.FolderItem, ...mediaItems];
          
          console.log(`Media loaded for folder ${folderId}:`, mediaItems);
        } else if (response && Array.isArray(response)) {
          // Handle direct array response (fallback)
          const mediaItems = response.map(item => ({
            id: item.imageId || item.id,
            name: item.imageName || item.name || item.fileName,
            url: item.imagePath ? `https://${item.imagePath}` : item.url || item.filePath,
            folderId: folderId,
            type: this.getFileTypeFromName(item.imageName || item.name || item.fileName),
          }));
          
          // Filter and replace items for this folder
          this.FolderItem = this.FolderItem.filter(item => item.folderId !== folderId);
          this.FolderItem = [...this.FolderItem, ...mediaItems];
          
          console.log(`Media loaded for folder ${folderId}:`, mediaItems);
        } else {
          console.log(`No media found for folder ${folderId}`);
          
          // Remove any existing items for this folder
          this.FolderItem = this.FolderItem.filter(item => item.folderId !== folderId);
        }
        
      } catch (error) {
        console.error(`Error fetching media for folder ${folderId}:`, error);
        
        // Show error toast
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: error.message || "Failed to load folder media",
          life: 5000,
        });
      }
    },
    browseBtn() {
      22222
      // this.$emit("uploadMinDesk");
      this.$refs.filedesktopexp.click();
    },
    handleFileChange(event) {
      // Store the original file for cropping purposes
      if (event.target.files && event.target.files.length > 0) {
        this.originalFile = event.target.files[0];
        console.log("Stored original file for cropping:", this.originalFile?.name);
      }
      this.$emit("handleFileUploadMediaEmit", event);
    },

    async handleFileUpload(event) {
      try {
        const file = event.target.files[0];
        if (!file) {
          console.warn("No file selected");
          return;
        }

        // Validate file type
        const validTypes = [
          'image/jpeg', 'image/jpg', 'image/gif', 'image/png', 
          'image/bmp', 'image/tiff', 'video/mp4'
        ];
        
        if (!validTypes.includes(file.type)) {
          this.$toast.add({
            severity: "error",
            summary: "Invalid File Type",
            detail: "Please upload a valid file (.jpeg, .jpg, .gif, .png, .bmp, .tiff, .mp4)",
            life: 3000,
          });
          this.$refs.filedesktopexp.value = "";
          return;
        }

        // Store the original file for cropping purposes
        this.originalFile = file;
        console.log("Stored original file for cropping:", this.originalFile?.name);

        // Generate preview for images
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = () => {
            this.localPreviewImageUrl = reader.result;
            this.localSelectedFile = file;
            console.log("Image preview generated");
          };
          reader.readAsDataURL(file);
        } else {
          // For videos, set a placeholder or video preview
          this.localPreviewImageUrl = null;
          this.localSelectedFile = file;
        }

        // Store the selected file for upload
        this.localSelectedFile = file;

        // Directly upload using presigned URL
        await this.uploadMediaToFolder(file);

        // Clear the input after successful upload
        this.$refs.filedesktopexp.value = "";
        this.localPreviewImageUrl = null;
        this.localSelectedFile = null;

        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: `File "${file.name}" uploaded successfully`,
          life: 3000,
        });

      } catch (error) {
        console.error("Error in handleFileUpload:", error);
        this.$toast.add({
          severity: "error",
          summary: "Upload Error",
          detail: error.message || "Failed to upload file",
          life: 5000,
        });
        
        // Clear input and reset state on error
        this.$refs.filedesktopexp.value = "";
        this.localPreviewImageUrl = null;
        this.localSelectedFile = null;
      }
    },
    cancelUpload() {
      this.localPreviewImageUrl = null;
      this.localSelectedFile = null;
      this.$refs.filedesktopexp.value = "";
      this.$emit("cancelUpload");
    },
    async saveUpload() {
      console.log(this.localSelectedFile,"selected File");
      
      // If we have a file to upload, call the API
      if (this.localSelectedFile) {
        try {
          const companyId = this.$store.state.cognitoInfo.companyid;
          const folderId = this.selectedFolder || (this.folders.length > 0 ? this.folders[0].id : '1');
          const fileName = this.localSelectedFile.name || 'uploaded_media';
          const filePath = this.localPreviewImageUrl || ''; // Use preview URL as file path
          
          // Call the /ai/add-image API
          const response = await DataLayerService.post(
            `/ai/add-image?cid=${companyId}&fid=${folderId}&iname=${encodeURIComponent(fileName)}&ipath=${this.objectKey}`
          );
          
          if (response) {
            // Add the uploaded image to local state
            const newMediaItem = {
              id: response.id || Date.now(),
              name: fileName,
              url: filePath,
              folderId: folderId,
              type: this.getFileType(this.localSelectedFile),
              originalFile: this.localSelectedFile // Store original file for cropping
            };
            
            // Add to FolderItem array
            this.FolderItem.push(newMediaItem);
            
            // Show success message
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: `Media "${fileName}" uploaded successfully`,
              life: 3000,
            });
            
            // Clear the local state
            this.localPreviewImageUrl = null;
            this.localSelectedFile = null;
            this.$refs.filedesktopexp.value = "";
            
            // Refresh media for the current folder
            setTimeout(async () => {
              await this.getMediaByFolder(folderId);
            }, 1000);
          }
        } catch (error) {
          console.error("Error calling /ai/add-image API:", error);
          this.$toast.add({
            severity: "error",
            summary: "Upload Error",
            detail: error.message || "Failed to upload media",
            life: 5000,
          });
        }
      } else {
        setTimeout(() => {
          this.getData();
        }, 5000);
      }
    },

    async uploadMediaToFolder(file) {
      try {
        const companyId = this.$store.state.cognitoInfo.companyid;
        const folderId = this.selectedFolder || (this.folders.length > 0 ? this.folders[0].id : '1');
        
        // Extract file name and file type
        const fileName = file.name || 'uploaded_media';
        const fileType = file.type.split("/")[1]; // Get file extension type (e.g., 'jpeg', 'png', 'mp4')
        
        console.log('Uploading media with presigned URL:', {
          companyId,
          folderId,
          fileName,
          fileType
        });

        // Step 1: Get presigned URL from the new AI endpoint
        const presignedResponse = await DataLayerService.get(
          `/ai/get-url?cid=${encodeURIComponent(companyId)}&fid=${encodeURIComponent(folderId)}&file=${encodeURIComponent(fileName)}&type=${encodeURIComponent(fileType)}`
        );
        if (!presignedResponse || !presignedResponse.url) {
          throw new Error("Failed to retrieve presigned URL");
        }

        const { url: presignedUrl, objectKey } = presignedResponse;
        console.log('Presigned URL obtained:', { presignedUrl, objectKey });
console.log(objectKey, "objkey");
        this.objectKey = objectKey;
        // Step 2: Upload file directly to S3 using presigned URL
        this.$store.commit("showLoader");
        
        console.log('Uploading file:', {
          fileName: file.name,
          fileType: file.type,
          fileSize: file.size,
          presignedUrl: presignedUrl.substring(0, 100) + '...' // Log partial URL for security
        });
        
        // Use axios for PUT request to S3
        const uploadResponse = await axios.put(presignedUrl, file, {
          headers: {
            'Content-Type': file.type,
          },
          onUploadProgress: ({ loaded, total }) => {
            const progress = Math.round((loaded * 100) / total);
            console.log(`Upload progress: ${progress}%`);
          },
        });

        if (uploadResponse && uploadResponse.status === 200) {
          console.log('S3 upload successful:', uploadResponse.status);
          
          // Return the upload data for further processing
          return {
            success: true,
            objectKey: objectKey,
            fileName: fileName,
            url: this.cleanS3Url(presignedUrl),
            folderId: folderId,
            fileType: this.getFileType(file)
          };
          
        } else {
          console.error('S3 upload failed:', {
            status: uploadResponse.status,
            statusText: uploadResponse.statusText,
            data: uploadResponse.data
          });
          throw new Error(`Failed to upload file to S3: ${uploadResponse.status} ${uploadResponse.statusText}`);
        }
        
      } catch (error) {
        console.error("Error uploading media:", error);
        
        // Show error message
        this.$toast.add({
          severity: "error",
          summary: "Upload Error", 
          detail: error.message || "Failed to upload media to folder",
          life: 5000,
        });
      } finally {
        this.$store.commit("hideLoader");
      }
    },

    cleanS3Url(url) {
      if (!url) return null;
      // Remove query parameters and clean the URL
      return url.split('?')[0].replace(
        /^https:\/\/s3\.eu-central-1\.amazonaws\.com\//,
        "https://"
      );
    },

    getFileType(file) {
      if (!file || !file.type) return 'image';
      
      if (file.type.startsWith('image/')) {
        return 'image';
      } else if (file.type.startsWith('video/')) {
        return 'video';
      } else {
        return 'image'; // Default to image
      }
    },

    getFileTypeFromName(fileName) {
      if (!fileName) return 'image';
      
      const extension = fileName.toLowerCase().split('.').pop();
      const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', '3gp'];
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp', 'svg'];
      
      if (videoExtensions.includes(extension)) {
        return 'video';
      } else if (imageExtensions.includes(extension)) {
        return 'image';
      } else {
        return 'image'; // Default to image
      }
    },
    // Handle file selection and create preview
    //  async handleFileUploadDesktopExp(event) {
    //   console.log("handleFileUploadDesktopExp");

    //       try {
    //         const file = event.target.files[0];
    //         console.log(file,"file");

    //             let reader = new FileReader();
    //             console.log(reader,"redeader");

    //         reader.onload = () => {
    //           var image = new Image();
    //           image.onload = () => {
    //           console.log("Image loaded, setting preview:", reader.result);
    //             this.previewImageUrlProp = reader.result; // Set local data property
    //             this.selectedFilePropedFile = file;
    //             this.imguploaded = true;
    //             console.log(this.previewImageUrlProp,"previewImageUrlProp");

    //             // this.vmodel1.ambCusHeadMobMinExpImglogoStream = reader.result;
    //             // this.vmodel1.ambCusHeadMobMinExpImgactualFileName = file.name;
    //             // this.vmodel1.ambCusHeadMobMinExpImglogoPath = reader.result;
    //             // this.vmodel1.ambCusHeadMobMinExpImgheight = image.height;
    //             // this.vmodel1.ambCusHeadMobMinExpImgwidth = image.width;

    //             this.$toast.add({
    //               severity: "success",
    //               summary: "Success",
    //               detail: this.uploadedSuccessfully,
    //               life: 3000,
    //             });
    //           };
    //           image.src = reader.result;
    //         };
    //         reader.readAsDataURL(file);

    //         // this.previewImageUrlProp = base64data;
    //         // this.selectedFileProp = file;
    //         // this.imguploaded = true;
    //         // this.imageUp = base64data;

    //         this.$toast.add({
    //           severity: "success",
    //           summary: "Success",
    //           detail: this.uploadedSuccessfully,
    //           life: 3000
    //         });
    //       } catch (error) {
    //         console.error("Error in handleFileUploadDesktopExp:", error);
    //         this.$toast.add({
    //           severity: "error",
    //           summary: "Error",
    //           detail: error.message || "Failed to process image",
    //           life: 5000
    //         });
    //         // this.$refs.filedesktopexp.value = "";
    //         this.previewImageUrlProp = null;
    //         this.selectedFileProp = null;
    //         this.imguploaded = false;
    //       }
    //     },

    // Handle drag-and-drop
    // handleDrop(event) {
    //   event.preventDefault();
    //   const file = event.dataTransfer.files[0];
    //   if (file) {
    //     const allowedTypes = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png', 'image/bmp', 'image/tiff'];
    //     if (!allowedTypes.includes(file.type)) {
    //       this.$toast.add({
    //         severity: 'error',
    //         summary: 'Invalid File Type',
    //         detail: 'Please upload a valid image file (.jpeg, .jpg, .gif, .png, .bmp, .tiff)',
    //         life: 3000,
    //       });
    //       return;
    //     }

    //     this.selectedFile = file;
    //     this.previewImageUrl = URL.createObjectURL(file);
    //   }
    // },

    // Cancel the upload and reset the preview

    // Post data to the server
    async selectFolder(folderId) {
      this.selectedFolder = folderId;
      this.selectedFolderItem = [];
      console.log(folderId,"folderIdfolderId");
      
      // Load media for the selected folder
      await this.getMediaByFolder(folderId);
    },
    async saveNewFolder() {
      if (this.newFolderName.trim()) {
        try {
          const companyId = this.$store.state.cognitoInfo.companyid;
          const folderName = this.newFolderName.trim();
          
          // Call API to create folder
          const response = await DataLayerService.post(
            `/ai/add-folder?cid=${companyId}&fname=${folderName}`
          );
          
          if (response) {
            // Show success message
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: `Folder "${folderName}" created successfully`,
              life: 3000,
            });
            
            // Refresh folders list from server after successful creation
            await this.getFolders(companyId);
            
            // Reset form and close popup
            this.newFolderName = "";
            this.NewFolderPopup = false;
          }
        } catch (error) {
          console.error("Error creating folder:", error);
          
          // Show error message
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error.message || "Failed to create folder",
            life: 5000,
          });
        }
      }
    },

    async removeBackground() {
      try {
        // Note: showLoader is already called in confirmRemoveBackground
        // Extract the S3 URI from the selected image URL
        // Remove the https:// prefix to get the S3 path
        let s3Uri = this.selectedImageUrl.replace(/^https?:\/\//, '');

        console.log('Removing background for image:', s3Uri);

        // Get authentication token and company ID from store
        const accessToken = this.$store.state.cognitoInfo.token;
        const companyId = this.$store.state.cognitoInfo.companyid;

        // Call the background removal API directly without /api/ prefix
        const response = await axios.post('https://manager-api.test.onsite.voyado.com/process-media', {
          s3_uri: s3Uri
        }, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            CompanyId: companyId == undefined || 
                      companyId == null || 
                      companyId == "undefined" || 
                      companyId == "null" ? "" : companyId,
            crossDomain: true,
            timeout: 200000,
            'Content-Type': 'application/json'
          }
        });

        // After receiving bgremoval response, hide loader and close popup
        // This happens in confirmRemoveBackground's try-catch

        if (response && response.status === 200 && response.data) {
          // If background removal is successful, call add-image API
          try {
            const folderId = this.selectedFolder || (this.folders.length > 0 ? this.folders[0].id : '1');
            const fileName = `bg_removed_${Date.now()}_${this.highlightedImageName || 'image'}`;
            
            // Use the original s3Uri as ipath parameter
            const addImageResponse = await DataLayerService.post(
              `/ai/add-image?cid=${companyId}&fid=${folderId}&iname=${encodeURIComponent(fileName)}&ipath=${encodeURIComponent(s3Uri)}`
            );
            
            if (addImageResponse) {
              console.log('Processed image added to library:', addImageResponse);
            }
          } catch (addImageError) {
            console.error('Error adding processed image to library:', addImageError);
            // Don't show error to user as background removal was successful
          }

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Background removal completed successfully. The processed image will be available shortly.",
            life: 5000,
          });

          // Refresh the current folder to see the new processed image
          setTimeout(async () => {
            await this.getMediaByFolder(this.selectedFolder);
          }, 2000);
        } else {
          throw new Error(response?.data?.message || "Background removal failed");
        }

      } catch (error) {
        console.error("Error removing background:", error);
        
        // Handle axios error response
        const errorMessage = error.response?.data?.message || error.message || "Failed to remove background from image";
        
        this.$toast.add({
          severity: "error",
          summary: "Background Removal Error",
          detail: errorMessage,
          life: 5000,
        });
      }
      // Note: No finally block with hideLoader - we use dialog spinner instead
    },

    openImageDialogBox() {
      this.imageAiPopup = true;
    },
    openVideoDialogBox() {
      this.videoAiPopup = true;
    },
    openContentGeneratingDialogBoxImage() {
      this.generatingContentPopUpImage = true;
      this.imageAiPopup = false;
      setTimeout(() => {
        this.generatingContentPopUpImage = false;
        this.imageCreatedPopup = true;
      }, 3000);
    },
    openContentGeneratingDialogBoxVideo() {
      this.generatingContentPopUpVideo = true;
      this.videoAiPopup = false;
      setTimeout(() => {
        this.generatingContentPopUpVideo = false;
        this.videoCreatedPopup = true;
      }, 3000);
    },
    openImageSettingVariantPopup() {
      this.ImageSettingVariantPopup = true;
    },
    openImageSettingInpaintingPopup() {
      this.ImageSettingInpaintingPopup = true;
    },
    openImageSettingOutpaintingPopup() {
      this.ImageSettingOutpaintingPopup = true;
    },
    openImageSettingResizePopup() {
      this.ImageSettingResizePopup = true;
    },
    openVideoSettingResizePopup() {
      this.VideoSettingResizePopup = true;
    },
    openVideoSettingTrimPopup() {
      this.VideoSettingTrimPopup = true;
    },
    openNewFolderPopup() {
      this.NewFolderPopup = true;
    },
    openBackgroundRemovalPopup() {
      // Validate that an image is selected
      if (!this.selectedImageUrl) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please select an image first to remove background.",
          life: 3000,
        });
        return;
      }
      this.backgroundRemovalPopup = true;
    },
    async confirmRemoveBackground() {
      // Don't close the dialog - keep it open and show loader
      // Set loading state to show spinner in dialog
      this.isRemovingBackground = true;
      
      try {
        // Call the actual background removal function
        await this.removeBackground();
        
        // Close the dialog only after successful completion
        this.backgroundRemovalPopup = false;
      } catch (error) {
        console.error('Error in confirmRemoveBackground:', error);
        // Close dialog even on error
        this.backgroundRemovalPopup = false;
      } finally {
        // Reset loading state
        this.isRemovingBackground = false;
      }
    },
    openCropConfirmationPopup() {
      // Validate that an image is selected
      if (!this.selectedImageUrl) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please select an image first to crop.",
          life: 3000,
        });
        return;
      }
      this.cropConfirmationPopup = true;
    },
    confirmCrop() {
      // Close the confirmation dialog
      this.cropConfirmationPopup = false;
      
      // Open the actual crop editor
      this.openImageSettingCropPopup();
    },
    async openImageSettingCropPopup() {
      console.log(
        "Opening cropper for selected image:",
        this.selectedImageUrl
      );
      
      // Validate that an image is selected
      if (!this.selectedImageUrl) {
        console.warn("No image available for cropping");
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail:
            "No image available for cropping. Please select an image first.",
          life: 3000,
        });
        return;
      }

      // Clear previous cropped images when starting to crop a new image
      this.croppedImages = [];
      this.selectedImagesForCrop = [];

      try {
        this.$store.commit("showLoader");
        
        // First try to use originalFile if available (avoids CORS)
        if (this.originalFile) {
          console.log("Using original file for cropping (no CORS issues)");
          this.localImageUrl = this.selectedImageUrl;
          this.cropperSrc = URL.createObjectURL(this.originalFile);
          console.log("Cropper source set to original file blob:", this.cropperSrc);
          this.ImageSettingCropPopup = true;
          this.$store.commit("hideLoader");
          return;
        }

        // If no original file, fetch the image and create a blob to avoid CORS
        console.log("No original file found, fetching image from S3 to avoid CORS...");
        
        try {
          // Use axios with specific CORS configuration
          const response = await axios.get(this.selectedImageUrl, {
            responseType: 'blob',
            headers: {
              'Accept': 'image/*',
            },
            timeout: 30000, // 30 second timeout
          });
          
          console.log("Image fetched successfully, creating blob URL...");
          const blob = await response.data;
          
          // Validate blob before using it
          if (!blob || blob.size === 0) {
            throw new Error("Received empty blob from axios");
          }
          
          console.log("Valid blob received:", {
            size: blob.size,
            type: blob.type
          });
          
          this.cropperSrc = URL.createObjectURL(blob);
          this.localImageUrl = this.selectedImageUrl;
          
          console.log("Successfully created blob URL for cropping:", this.cropperSrc);
          this.ImageSettingCropPopup = true;
          
        } catch (axiosError) {
          console.warn("Axios fetch failed, trying native fetch with CORS...", axiosError.message);
          
          try {
            // Try regular fetch first (with CORS)
            const response = await fetch(this.selectedImageUrl, {
              mode: 'cors',
              cache: 'no-cache',
              headers: {
                'Accept': 'image/*',
              }
            });
            
            console.log("Regular fetch response:", {
              ok: response.ok,
              status: response.status,
              type: response.type,
              url: response.url
            });
            
            if (response.ok) {
              const blob = await response.blob();
              console.log("Blob created:", {
                size: blob.size,
                type: blob.type
              });
              
              if (blob.size > 0 && blob.type.startsWith('image/')) {
                this.cropperSrc = URL.createObjectURL(blob);
                this.localImageUrl = this.selectedImageUrl;
                
                console.log("Successfully created blob URL with regular fetch:", this.cropperSrc);
                console.log("Opening cropper popup...");
                this.ImageSettingCropPopup = true;
                return;
              } else {
                throw new Error(`Invalid blob - size: ${blob.size}, type: ${blob.type}`);
              }
            } else {
              throw new Error(`Fetch failed: ${response.status}`);
            }
          } catch (regularFetchError) {
            console.warn("Regular fetch also failed:", regularFetchError.message);
            
            // As absolute last resort, try using the direct URL
            console.log("All fetch methods failed, using direct URL (may have CORS issues)...");
            this.cropperSrc = this.selectedImageUrl;
            this.localImageUrl = this.selectedImageUrl;
            this.ImageSettingCropPopup = true;
            
            // Show informative warning
            this.$toast.add({
              severity: "warn",
              summary: "CORS Warning",
              detail: "Loading image directly due to CORS restrictions. If cropping fails, please re-upload the image.",
              life: 5000,
            });
          }
        }
        
      } catch (error) {
        console.error("Error preparing image for cropping:", error);
        
        // As a last resort, try to use the original URL directly with CORS headers
        console.log("All fetch methods failed, trying direct URL with CORS...");
        this.cropperSrc = this.selectedImageUrl;
        this.localImageUrl = this.selectedImageUrl;
        this.ImageSettingCropPopup = true;
        
        // Show warning but still open the cropper
        this.$toast.add({
          severity: "warn",
          summary: "Warning",
          detail: "Image loaded directly - you may experience CORS issues. If cropping fails, please re-upload the image.",
          life: 5000,
        });
      } finally {
        this.$store.commit("hideLoader");
      }
    },
    openVideoSettingCropPopup() {
      this.VideoSettingCropPopup = true;
    },
    async applyCrop() {
      if (this.croppedImages.length >= 2) return;
      const cropper = this.$refs.cropperComponent;
      if (cropper) {
        const { canvas } = cropper.getResult();
        if (!canvas) {
          console.error("Cropper canvas not available");
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Failed to capture cropped image.",
            life: 3000,
          });
          return;
        }

        // Convert canvas to blob to avoid CORS issues
        const blob = await new Promise((resolve) => {
          canvas.toBlob((blob) => resolve(blob), "image/png");
        });
        
        if (!blob) {
          console.error("Failed to create blob from canvas");
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Failed to process cropped image.",
            life: 3000,
          });
          return;
        }

        // Create file from blob
        const file = new File(
          [blob],
          `cropped_${Date.now()}.png`,
          { type: "image/png" }
        );

        // Create object URL for immediate display
        const croppedUrl = URL.createObjectURL(blob);

        this.croppedImages.push({
          id: `crop-${this.croppedImages.length + 1}`,
          name: `Cropped ${this.croppedImages.length + 1}`,
          url: croppedUrl,
          folderId: this.selectedFolder,
          file: file, // Store the file for potential upload
        });

        // Auto-select the newly created cropped image
        this.selectedImagesForCrop = [this.croppedImages.length];

        // Reset cropper to original image
        cropper.reset();

        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: "Image cropped successfully.",
          life: 3000,
        });
      }
    },
    clearCroppedImages() {
      this.croppedImages = [];
      this.selectedImagesForCrop = [];
    },
    handleCrop() {
      // Check if any cropped images are selected
      if (this.selectedImagesForCrop.length === 0) {
        // Show a warning message to select an image first
        this.$toast.add({
          severity: "warn",
          summary: "Selection Required",
          detail: "Please select an image (original or cropped) to save.",
          life: 3000,
        });
        return;
      }
      // Find the original image item in FolderItem
      const originalImageIndex = this.FolderItem.findIndex(
        (item) =>
          item.url === this.selectedImageUrl &&
          item.name === this.highlightedImageName
      );
      console.log(this.selectedImageUrl,"selectedImageUrl staart");
      
      if (originalImageIndex !== -1) {
        // Get the selected image to replace with
        let selectedImage = null;
        // Check if original image (index 0) is selected
        if (this.selectedImagesForCrop.includes(0)) {
          // Keep the original image as is
          selectedImage = {
            url: this.selectedImageUrl,
            name: this.highlightedImageName,
          };
        } else {
          // Get the first selected cropped image
          const selectedCropIndex = this.selectedImagesForCrop.find(
            (index) => index > 0
          );
          if (selectedCropIndex && this.croppedImages[selectedCropIndex - 1]) {
            selectedImage = this.croppedImages[selectedCropIndex - 1];
          }
        }
        if (selectedImage) {
          // If a cropped image is selected (not the original), upload it to the server
          if (!this.selectedImagesForCrop.includes(0) && selectedImage.file) {
            this.uploadCroppedImage(selectedImage);
          }
          
          // Replace the original image with the selected one
          this.FolderItem[originalImageIndex] = {
            ...this.FolderItem[originalImageIndex],
            url: selectedImage.url,
            name:
              selectedImage.name || this.FolderItem[originalImageIndex].name,
          };
          // Update the selectedImageUrl to reflect the change
          this.selectedImageUrl = selectedImage.url;
          this.highlightedImageName =
            selectedImage.name || this.highlightedImageName;
        }
        console.log(this.selectedImageUrl, "selectedImageUrlselectedImageUrl");

      }
      // Close the crop popup and the highlighted image settings popup
      this.ImageSettingCropPopup = false;
      this.highlightedImageSettingsPopup = false;
      this.selectedImagesForCrop = [];
      this.cleanupCropperResources();
    },

    cleanupCropperResources() {
      // Clean up blob URLs to prevent memory leaks
      if (this.cropperSrc && this.cropperSrc.startsWith('blob:')) {
        URL.revokeObjectURL(this.cropperSrc);
        this.cropperSrc = null;
      }
    },

    onCropperError(error) {
      console.error("Cropper error:", error);
      
      // Check if the error is due to an invalid or empty blob
      if (this.cropperSrc && this.cropperSrc.startsWith('blob:')) {
        console.log("Blob URL detected, checking if valid...");
        
        // Try to create an image to test if the blob is valid
        const testImage = new Image();
        testImage.onload = () => {
          console.log("Blob is valid, cropper error is unrelated to CORS");
        };
        testImage.onerror = () => {
          console.log("Blob is invalid, retrying with direct URL...");
          this.retryWithDirectUrl();
        };
        testImage.src = this.cropperSrc;
      }
      
      this.$toast.add({
        severity: "error",
        summary: "Cropper Error",
        detail: "Failed to load image in cropper. Trying alternative loading method...",
        life: 5000,
      });
    },

    retryWithDirectUrl() {
      console.log("Retrying cropper with direct URL...");
      
      // Clean up the invalid blob URL
      if (this.cropperSrc && this.cropperSrc.startsWith('blob:')) {
        URL.revokeObjectURL(this.cropperSrc);
      }
      
      // Use the direct S3 URL
      this.cropperSrc = this.selectedImageUrl;
      
      this.$toast.add({
        severity: "info",
        summary: "Retrying",
        detail: "Attempting to load image directly. If this fails, please re-upload the image.",
        life: 3000,
      });
    },

    onCropperReady() {
      console.log("Cropper is ready and image loaded successfully");
      this.$toast.add({
        severity: "success",
        summary: "Ready",
        detail: "Image loaded successfully in cropper",
        life: 2000,
      });
    },

    onCropperChange(data) {
      console.log("Cropper change event:", data);
      // This event fires when the cropper state changes
    },
    async uploadCroppedImage(croppedImage) {
      try {
        this.$store.commit("showLoader");
        
        const companyId = this.$store.state.cognitoInfo.companyid;
        const folderId = this.selectedFolder || (this.folders.length > 0 ? this.folders[0].id : '1');
        
        // Upload the cropped image file first
        const uploadResult = await this.uploadMediaToFolder(croppedImage.file);
        
        if (uploadResult && uploadResult.success) {
          // Call add-image API to register the cropped image
          const fileName = `cropped_${Date.now()}_${this.highlightedImageName || 'image'}`;
          
          const addImageResponse = await DataLayerService.post(
            `/ai/add-image?cid=${companyId}&fid=${folderId}&iname=${encodeURIComponent(fileName)}&ipath=${encodeURIComponent(uploadResult.objectKey)}`
          );
          
          if (addImageResponse) {
            console.log('Cropped image uploaded and registered:', addImageResponse);
            
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "Cropped image saved successfully to your media library.",
              life: 3000,
            });
            
            // Refresh the folder to show the new cropped image
            setTimeout(async () => {
              await this.getMediaByFolder(folderId);
            }, 1000);
          }
        }
      } catch (error) {
        console.error("Error uploading cropped image:", error);
        this.$toast.add({
          severity: "error",
          summary: "Upload Error",
          detail: error.message || "Failed to save cropped image",
          life: 5000,
        });
      } finally {
        this.$store.commit("hideLoader");
      }
    },
    // Additionally, you might want to update the selectImageForCrop method to allow only single selection:
    selectImageForCrop(index) {
      console.log(111);
      
      // Allow only single selection for crop save functionality
      this.selectedImagesForCrop = [index];
      console.log(this.selectedImagesForCrop,"selectedImagesForCrop");
      
    },
    deleteCroppedImage(index) {
      // Remove the cropped image from the array
      this.croppedImages.splice(index, 1);
      // Update selected images for crop - if the deleted image was selected, remove it
      // Also update indices for images that come after the deleted one
      this.selectedImagesForCrop = this.selectedImagesForCrop
        .filter((selectedIndex) => selectedIndex !== index + 1) // Remove the deleted image from selection
        .map((selectedIndex) => {
          // Adjust indices for images that come after the deleted one
          if (selectedIndex > index + 1) {
            return selectedIndex - 1;
          }
          return selectedIndex;
        });
    },

    resetState() {
      this.selectedFolderItem = [];
      this.showCreateDropdown = false;
      this.searchQuery = "";
      this.imageAiPopup = false;
      this.videoAiPopup = false;
      this.generatingContentPopUpImage = false;
      this.generatingContentPopUpVideo = false;
      this.imageCreatedPopup = false;
      this.videoCreatedPopup = false;
      this.contentDescription = "";
      this.negativeText = "";
      this.width = "";
      this.height = "";
      this.quality = "";
      this.cfgScale = "";
      this.seed = "";
      this.numImages = "";
      this.saveFolder = "";
      this.highlightedImageSettingsPopup = false;
      this.highlightedVideoSettingsPopup = false;
      this.highlightedImageName = "";
      // this.croppedImages = [];
      // this.selectedImagesForCrop = [];
    },
    toggleCreateDropdown() {
      this.showCreateDropdown = !this.showCreateDropdown;
    },
    openHighlightedSettingsPopup(item) {
      this.highlightedImageName = item.name;
      this.selectedImageUrl = item.url;

      // If this is a recently uploaded file, try to find the original file
      if (item.originalFile) {
        this.originalFile = item.originalFile;
        console.log("Found original file for cropping:", this.originalFile.name);
      } else if (this.localSelectedFile && this.localPreviewImageUrl === item.url) {
        // If the selected item matches the recently uploaded file
        this.originalFile = this.localSelectedFile;
        console.log("Using recently uploaded file for cropping:", this.originalFile.name);
      } else {
        // Clear originalFile for existing S3 images
        this.originalFile = null;
        console.log("No original file available for this image, will use fetch method");
      }

      if (item.type === "video") {
        // Store additional info for trimmed videos
        if (item.isTrimmed) {
          this.currentTrimData = item.trimData;
        }
        this.highlightedVideoSettingsPopup = true;
      } else {
        this.highlightedImageSettingsPopup = true;
      }
    },

    toggleSelection(item) {
      // Allow only one item to be selected at a time
      if (this.selectedFolderItem.includes(item.id)) {
        // If the item is already selected, deselect it
        this.selectedFolderItem = [];
      } else {
        // Select the new item, replacing any previous selection
        this.selectedFolderItem = [item.id];
      }
    },

    handleEditButtonClick() {
      if (this.selectedFolderItem.length === 0) {
        alert('Please select an item to edit.');
        return;
      }

      // Find the first selected item
      const firstSelectedItem = this.filteredFolderItem.find(item =>
        this.selectedFolderItem.includes(item.id)
      );

      if (firstSelectedItem) {
        this.openHighlightedSettingsPopup(firstSelectedItem);
      } else {
        alert('Selected item not found.');
      }
      this.cropperSrc = this.selectedImageUrl;
    },

    selectImage(image) {
      if (this.multiple) {
        const index = this.selectedFolderItem.indexOf(image.id);
        if (index > -1) {
          this.selectedFolderItem.splice(index, 1);
        } else {
          this.selectedFolderItem.push(image.id);
        }
      } else {
        this.selectedFolderItem = [image.id];
      }
    },
    selectImageForResize(image) {
      if (this.multiple) {
        const index = this.selectedImagesForResize.indexOf(image.id);
        if (index > -1) {
          this.selectedImagesForResize.splice(index, 1);
        } else {
          this.selectedImagesForResize.push(image.id);
        }
      } else {
        this.selectedImagesForResize = [image.id];
      }
    },
    chooseSelected() {
      const selected = this.FolderItem.filter((img) =>
        this.selectedFolderItem.includes(img.id)
      );
      this.$emit("select", this.multiple ? selected : selected[0]);
      this.$emit("update:visible", false);
    },
    // handleDrop(event) {
    //   event.preventDefault();
    //   const files = Array.from(event.dataTransfer.files);
    //   this.$emit("upload", files);
    // },
    handleAddFolder(folderData) {
      this.folders.push({
        id: Date.now(),
        name: folderData.name,
      });
    },
    handleCreateImage(imageData) {
      this.FolderItem.push({
        id: Date.now(),
        name: imageData.name,
        url: imageData.url,
        folderId: this.selectedFolder,
      });
    },
    async getLabel() {
      const languageCode = localStorage.getItem("selectedLanguage") || "en";
      try {
        const response = await DataLayerService.get(
          `/resource/${languageCode}`
        );
        const updatedLModel = {};
        Object.keys(response).forEach((key) => {
          const lowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
          updatedLModel[lowerCaseKey] = response[key];
        });
        this.lmodel = updatedLModel;
      } catch (error) {
        console.error("Error fetching labels:", error);
      }
    },
    goToFolder() {
      this.imageCreatedPopup = false;
      this.videoCreatedPopup = false;
    },
    handleSaveImage() {
      this.imageCreatedPopup = false;
      this.videoCreatedPopup = false;
    },
    saveHighlightedImageSettings() {
      // ADDED: Method to save settings from new popup
      const imageIndex = this.FolderItem.findIndex(
        (img) => img.name === this.highlightedImageName
      );
      if (imageIndex !== -1) {
        this.FolderItem[imageIndex].name = this.highlightedImageName;
        // Add logic to update width, height, quality if needed
      }
      this.highlightedImageSettingsPopup = false; // Close the popup
    },
    saveHighlightedVideoSettings() {
      // ADDED: Method to save settings from new popup
      const imageIndex = this.FolderItem.findIndex(
        (img) => img.name === this.highlightedImageName
      );
      if (imageIndex !== -1) {
        this.FolderItem[imageIndex].name = this.highlightedImageName;
        // Add logic to update width, height, quality if needed
      }
      this.highlightedVideoSettingsPopup = false; // Close the popup
    },
    onVideoLoaded() {
      this.duration = this.$refs.videoElement.duration;
      this.trimEnd = this.duration;
    },

    onTimeUpdate() {
      this.currentTime = this.$refs.videoElement.currentTime;
    },

    onVideoEnded() {
      this.isPlaying = false;
    },

    togglePlayPause() {
      if (this.isPlaying) {
        this.$refs.videoElement.pause();
      } else {
        this.$refs.videoElement.play();
      }
      this.isPlaying = !this.isPlaying;
    },

    onTimelineMouseDown(event) {
      if (event.target.classList.contains("trim-handle")) return;

      const rect = this.$refs.timelineWrapper.getBoundingClientRect();
      const clickPosition = (event.clientX - rect.left) / rect.width;
      const clickTime = clickPosition * this.duration;

      this.currentTime = clickTime;
      this.$refs.videoElement.currentTime = clickTime;
    },

    onStartHandleMouseDown(event) {
      event.stopPropagation();
      this.isDragging = true;
      this.dragType = "start";
      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("mouseup", this.onMouseUp);
    },

    onEndHandleMouseDown(event) {
      event.stopPropagation();
      this.isDragging = true;
      this.dragType = "end";
      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("mouseup", this.onMouseUp);
    },

    onMouseMove(event) {
      if (!this.isDragging) return;

      const rect = this.$refs.timelineWrapper.getBoundingClientRect();
      const position = Math.max(
        0,
        Math.min(1, (event.clientX - rect.left) / rect.width)
      );
      const time = position * this.duration;

      if (this.dragType === "start") {
        this.trimStart = Math.max(0, Math.min(time, this.trimEnd - 0.1));
      } else if (this.dragType === "end") {
        this.trimEnd = Math.max(
          this.trimStart + 0.1,
          Math.min(time, this.duration)
        );
      }
    },

    onMouseUp() {
      this.isDragging = false;
      this.dragType = null;
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseUp);
    },

    formatTime(seconds) {
      if (!seconds || isNaN(seconds)) return "00:00:00";

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    },

    resetTrim() {
      this.trimStart = 0;
      this.trimEnd = this.duration;
    },

    previewTrim() {
      this.$refs.videoElement.currentTime = this.trimStart;
      this.currentTime = this.trimStart;
      this.$refs.videoElement.play();
      this.isPlaying = true;

      // Stop at trim end
      const checkTime = () => {
        if (this.currentTime >= this.trimEnd) {
          this.$refs.videoElement.pause();
          this.isPlaying = false;
        } else if (this.isPlaying) {
          requestAnimationFrame(checkTime);
        }
      };
      checkTime();
    },

    saveTrim() {
      const trimData = {
        startTime: this.trimStart,
        endTime: this.trimEnd,
        duration: this.trimEnd - this.trimStart,
        originalDuration: this.duration,
        originalUrl: this.selectedImageUrl,
        originalName: this.highlightedImageName,
      };

      console.log("Trim data:", trimData);

      // Create trimmed video entry using trimData
      const trimmedVideo = {
        id: Date.now(),
        name: `${trimData.originalName}_trimmed_${this.formatTimeForFilename(
          trimData.startTime
        )}-${this.formatTimeForFilename(trimData.endTime)}`,
        url: trimData.originalUrl,
        folderId: this.selectedFolder,
        type: "video",
        isTrimmed: true,
        trimData: trimData, // Now we're using the trimData variable
        originalVideoId: this.getOriginalVideoId(),
        createdAt: new Date().toISOString(),
      };

      // Add to FolderItem array
      this.FolderItem.push(trimmedVideo);

      // Close the trim popup
      this.VideoSettingTrimPopup = false;

      // Show success message
      this.showTrimSuccessMessage(trimmedVideo);
    },

    // Helper method to format time for filename
    formatTimeForFilename(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${minutes}m${secs}s`;
    },

    // Helper method to get original video ID
    getOriginalVideoId() {
      const originalVideo = this.FolderItem.find(
        (item) =>
          item.url === this.selectedImageUrl &&
          item.type === "video" &&
          !item.isTrimmed
      );
      return originalVideo ? originalVideo.id : null;
    },

    // Show success message
    showTrimSuccessMessage(trimmedVideo) {
      // You can show a toast notification or update UI
      console.log("Trimmed video created:", trimmedVideo);

      // Optional: Show the video created popup
      this.videoCreatedPopup = true;
    },
  },
  created() {
    setTimeout(async () => {
      await this.getLabel();
    }, 100);
    this.$store.watch(
      (state) => state.selectedLanguage,
      (newLanguage, oldLanguage) => {
        if (newLanguage !== oldLanguage) {
          this.getLabel();
        }
      }
    );
  },
  props: {
    id: {
      type: String,
      default: "media-library",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Media library",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    previewImageUrl: {
      type: String,
      required: true,
    },
    selectedFile: {
      type: String,
      required: true,
    },
  },
  emits: ["update:visible", "select", "upload", "handleFileUploadMediaEmit", "cancelUpload"],
  computed: {
    previewImageUrlProp: {
      get() {
        return this.previewImageUrl;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    selectedFileProp: {
      get() {
        return this.selectedFile;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    filteredFolders() {
      if (!this.searchQuery) return this.folders;
      return this.folders.filter((folder) =>
        folder.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    filteredFolderItem() {
      return this.FolderItem.filter(
        (image) => image.folderId === this.selectedFolder
      );
    },
    filteredImages() {
      return this.staticResizedImages.filter(
        (image) => image.folderId === this.selectedFolder
      );
    },
  },

  mounted() {
    const dialog = this.$refs.dialogRef;
    if (this.visible && dialog && !dialog.open) {
      try {
        dialog.showModal();
        document.body.classList.add("no-scroll", "dialog-open");
      } catch (err) {
        console.warn("Dialog already open on mount:", err);
      }
    }

    // Close dropdown when clicking outside
  },
  beforeUnmount() {
    document.body.classList.remove("no-scroll", "dialog-open");
    if (this.$refs.dialogRef && this.$refs.dialogRef.open) {
      this.$refs.dialogRef.close();
    }

    // Add video trimmer cleanup
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);

    // Clean up blob URLs to prevent memory leaks
    if (this.cropperSrc && this.cropperSrc.startsWith('blob:')) {
      URL.revokeObjectURL(this.cropperSrc);
    }
    if (this.localPreviewImageUrl && this.localPreviewImageUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.localPreviewImageUrl);
    }
  },
};
</script>
<style lang="scss" scoped>
// Base dialog styles
.media-library-dialog {
  overflow: visible;
  position: fixed !important;
}

.media-library-dialog {
  width: 95%;
  height: 100vh;
  border: 1px solid #c0c0bc;
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  font-family: "Voyado Text", sans-serif;
  color: #21211f;
  padding: 0;
}

.media-library-dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  font-size: 18px;
  border-bottom: 1px solid #e9ecef;
  background: #fff;
  color: #000000;
  position: sticky; /* Make header sticky */
  top: 0; /* Stick to top */
  z-index: 10; /* Ensure it stays above content */
  border-radius: 4px 4px 0px 0px;

  span {
    font-family: "Voyado Display";
    font-weight: 500;
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.dropdown-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  position: relative;
  margin-bottom: 6px;
}

.create-button {
  background: #2d6e6d;
  color: white;
  border: none;
  padding: 13px 7px 13px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;

  i {
    margin-top: 2px;
  }

  span {
    margin-top: 7px;
  }
}

.button-divider {
  border: 1px solid #fff;
  height: 40px;
  // margin: -20px 0px;
}

.plus-icon {
  font-weight: bold;
}

.chevron-icon {
  font-size: 12px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  margin-top: 9px;
  right: 0;
  background: white;
  border: 1px solid #c0c0bc;
  border-radius: 4px;
  box-shadow: 0 13px 13px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 120px;
}

.dropdown-item {
  width: 100%;
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: "Voyado Text";
}

.dropdown-item:hover {
  background: #f5f5f5;
  border-radius: 4px;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
}

.close-button:hover {
  color: #21211f;
}

// .dialog-content {
//   flex: 1;
//   overflow: hidden;
//   padding: 0;
// }

// .media-content {
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   overflow: hidden;
// }

.media-layout {
  display: flex;
  height: calc(100% - 128px);
  overflow: hidden;
}

.sidebar {
  min-width: 250px;
  background: #fff;
  border-right: 1px solid #e9ecef;
  padding: 1rem;
  overflow-y: auto;
  height: 100%;
}

.search-container {
  margin-bottom: 1rem;
}

.search-input-wrapper {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.search-input {
  width: 100%;
  padding: 0.5rem 0.5rem 0.5rem 2rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}

.search-input:focus {
  outline: none;
  border-color: #2d6e6d;
  box-shadow: 0 0 0 2px rgba(45, 110, 109, 0.2);
}

.add-folder-button {
  width: 100%;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.2rem;
  font-size: 14px;
  margin-bottom: 1rem;

  i {
    margin-top: 4px;
  }
}

.folder-list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.folder-item {
  width: 100%;
  text-align: left;
  padding: 0.5rem;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 13px;
  font-family: "Voyado Text";
}

.folder-item:hover {
  background: #e9ecef;
  font-family: "Voyado Text";
}

.folder-item.active {
  background: #f8f8f7;
}

.folder-icon {
  font-size: 16px;
}

.main-content {
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
  height: 100%;
}

.upload-area {
  border: 2px dashed #ced4da;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  margin-bottom: 1.5rem;
  cursor: pointer;
  transition: border-color 0.2s;
}

.upload-area:hover {
  border-color: #2d6e6d;
}

.upload-file-container {
  background-color: #f8f8f7;
  border: 2px dashed #e2e2e2;
  margin: 20px 0px;
  padding: 20px;
  display: flex;
  justify-content: center;
  justify-content: space-between;
  border-radius: 8px;
  align-items: center;
}

.upload-text-parent {
  display: flex;
  align-items: center;
  gap: 3px;

  p {
    margin-left: 3px;
  }
}

.upload-icon {
  margin-top: 2px;
  font-size: 2rem;
  display: block;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
}

.image-item {
  position: relative;
  // min-height: 173px;
  // min-width: 189px;
  cursor: pointer;
  border: 2px solid transparent;
  overflow: hidden;
  transition: border-color 0.2s;
}
.image-grid-with-transition-label {
  height: 120px;
}

.image-item:hover {
  border-color: #ced4da;
}

.image-item.selected {
  border-color: #000;
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(45, 110, 109, 0.2);
  height: 120px;
}

.image-thumbnail {
  width: 100%;
  height: 120px;
  object-fit: cover;
}
.image-thumbnail-resize {
  width: 100%;
  height: 120px;
  object-fit: fill;
}

.image-label {
  background: rgba(0, 0, 0, 0.7);
  padding: 0.5rem;
  background: #f8f8f7;
  color: black;
}

.image-label-resize {
  color: #fff;
  position: absolute;
  bottom: 0px;
  display: flex;
  height: 29px;
  background: rgba(0, 0, 0, 0.64);
  width: 100%;
  text-align: center;
  font-family: "Voyado Text";
  font-size: 12.64px;
  font-style: normal;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.image-label p {
  margin: 0;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selection-indicator {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 20px;
  height: 20px;
  background: #2d6e6d;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}
.selection-indicator-resize {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 20px;
  height: 20px;
  background: #bf1100;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.dialog-footer {
  position: sticky;
  overflow: hidden;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background-color: #f8f8f7;
  bottom: 0; /* Stick to bottom */
  z-index: 10;
  border-radius: 0px 0px 4px 4px;
}

.cancel-button {
  padding: 0.5rem 1rem;
  border: 1px solid #ced4da;
  background: white;
  color: #6c757d;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button:hover {
  background: #f8f9fa;
}

.choose-button {
  padding: 0.5rem 1rem;
  border: none;
  background: #2d6e6d;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.choose-button:hover {
  background: #245a59;
}

.choose-button:disabled {
  background: #ced4da;
  cursor: not-allowed;
}

.folder-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}

.folder-input:focus {
  outline: none;
  border-color: #2d6e6d;
  box-shadow: 0 0 0 2px rgba(45, 110, 109, 0.2);
}

@media (max-width: 768px) {
  .media-layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    height: 55%;
  }
}

body.no-scroll {
  overflow: hidden;
}

body.dialog-open .media-library-dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

// Image And Video dialog css
.image-ai-dialog {
  position: fixed !important;
  max-width: 65% !important;
  height: 80%;
  overflow: auto;
}

:deep(.image-ai-dialog) {
  textarea {
    height: 97px !important;
  }
}

:deep(.image-ai-dialog) {
  .dialog-header {
    // height: 97px !important;
    position: sticky;
  }
}

.video-ai-dialog {
  position: fixed !important;
  max-width: 65% !important;
  height: 80%;
  overflow: auto;
}

:deep(.video-ai-dialog) {
  textarea {
    height: 97px !important;
  }
}

// Loader PopUp
.loader-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
}

.loader-message {
  color: #21211f;
  font-family: "Voyado Text", sans-serif;
  font-size: 16px;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  padding: 0 67px;

  :deep(.label-text) {
    margin-bottom: 0px;
    font-size: 20px;
    line-height: 20.5px;
  }

  :deep(.control-label) {
    font-size: 16px;
    line-height: 19.2px;
  }
}

.dismiss-button {
  padding: 0.5rem 1.5rem;
  border: 1px solid #ced4da;
  background: #ffffff;
  color: #2d6e6d;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.dismiss-button:hover {
  background: #f8f9fa;
}

// Created image/video successfully
.created-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
}

.check-icon {
  font-size: 40px;
  color: #2d6e6d;
  margin-bottom: 1rem;
}

.message {
  color: #21211f;
  font-family: "Voyado Text", sans-serif;
  font-size: 20px;
  line-height: 20.5px;
  margin-bottom: 22px;
  margin-top: 31px;
}

.buttons {
  display: flex;
  gap: 1rem;
}

.dismiss-button {
  padding: 0.5rem 1.5rem;
  border: 1px solid #ced4da;
  background: #ffffff;
  color: #2d6e6d;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.dismiss-button:hover {
  background: #f8f9fa;
}

.go-to-folder-button {
  padding: 0.5rem 1.5rem;
  background: #2d6e6d;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.go-to-folder-button:hover {
  background: #245655;
}

.created-dialogbox :deep(.dialog-footer) {
  display: none;
}

/* New Highlighted Image Settings Popup */
.highlighted-image-settings-dialog {
  height: 100% !important;
  top: 0;
  right: 0;
  z-index: 1001;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  // border-radius: var(--border-radius);
  display: block;
}

.highlighted-settings-content {
  /* ADDED: Content styling */
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 4px;
}

// nestted popup css in image setting buttons
.image-setting-onclick-butoon {
  position: fixed !important;
  max-width: 65% !important;
  height: 80%;
  overflow: auto;
}
.image-setting-onclick-butoon-resize {
  position: fixed !important;
  max-width: 40% !important;
  height: 80%;
  overflow: auto;
}
// Add these styles to your existing <style> section

// Video Trimmer Styles
.video-trimmer-container {
  padding: 20px;
  max-width: 100%;
}

.video-preview-section {
  margin-bottom: 20px;
}

.preview-video {
  width: 100%;
  max-height: 300px;
  border-radius: 8px;
  background: #000;
}

.video-controls {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
}

.control-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.control-icon {
  font-size: 16px;
  line-height: 1;
}

.time-display {
  font-family: "Courier New", monospace;
  font-weight: bold;
  color: #333;
}

.timeline-container {
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #c3d4d3;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-family: "Courier New", monospace;
  font-size: 14px;
  color: #666;
}

.timeline-wrapper {
  position: relative;
  width: 100%;
  height: 50px; /* Adjust as needed */
}

.timeline-track {
  position: relative;
  width: 100%;
  height: 100%;
}

.timeline-thumbnails {
  display: flex;
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 1; /* Thumbnails at the bottom layer */
}

.timeline-thumbnail {
  flex: 1 1 0%;
}

.trimmed-section-overlay {
  position: absolute;
  top: 0;
  height: 100%;
  border-top: 2px solid #2313b6; /* Adjust color/thickness as needed */
  border-bottom: 2px solid #2313b6; /* Adjust color/thickness as needed */
  z-index: 2; /* Above thumbnails, below handles/indicator */
  border-radius: 8px 0 0 8px;
}

.current-time-indicator {
  position: absolute;
  top: 0;
  width: 2px;
  height: 100%;
  background-color: red; /* Adjust as needed */
  z-index: 3; /* Above overlay */
}

.trim-handle {
  position: absolute;
  top: 0;
  width: 10px;
  height: 100%;
  background-color: #2313b6; /* Adjust as needed */
  cursor: ew-resize;
  z-index: 4; /* Topmost layer */
}

// .trim-handle:hover {
//   left: 2%;
//   background: #2313B6;
//   transform: translateX(-10px) scale(1.1);
// }

.trim-handle::after {
  content: "";
  left: 2%;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3px;
  height: 20px;
  transform: translate(-50%, -50%);
  border-radius: 2px;
}

.trim-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.trim-details {
  display: flex;
  justify-content: space-around;
  font-family: "Courier New", monospace;
  font-size: 14px;
  color: #333;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-actions,
.right-actions {
  display: flex;
  gap: 10px;
}

.btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

// Cropper specific styles
.imagefit {
  max-height: 400px;
  width: 100%;
}

.cropper-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  color: #6c757d;
  font-style: italic;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2d6e6d;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.cropper-debug {
  background: #f8f9fa;
  padding: 5px 10px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 11px;
  color: #666;
  margin-bottom: 10px;
  word-break: break-all;
}

.btn-primary {
  background: #2d6e6d;
  color: white;
}

.btn-primary:hover {
  background: #245a59;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #545b62;
}

.btn-icon {
  font-size: 15px;
  line-height: 1;
}

@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 15px;
  }

  .left-actions,
  .right-actions {
    width: 100%;
    justify-content: center;
  }

  .trim-details {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
}

.start-handle {
  left: -2%;
  border-radius: 8px 0 0 8px;
}
.end-handle {
  // left: 2%;
  border-radius: 0px 8px 8px 0px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.folder-name-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
